/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { action } from "@ember/object";
import CrudJournalEventBaseComponent from "parog-web/components/forc/abstract/crud-journal-event-based-component";
import journalEventRetrievalStrategies from "parog-web/components/forc/utils/journal-event-retrieval-strategies";
import InterTreatmentFilledJournalEvent from "parog-web/models/inter-treatment-filled-journal-event";

export default class extends CrudJournalEventBaseComponent<InterTreatmentFilledJournalEvent> {
  static forcDisplayName = "Questionnaire intercure";
  static fullComponentId = "inter-treatment/consult-form";

  static journalEventClass = InterTreatmentFilledJournalEvent;
  retrieveJournalEvent = journalEventRetrievalStrategies.sourceJournalEvent;

  get sections(): Array<string> {
    return InterTreatmentFilledJournalEvent.sections;
  }

  @action
  async beforeSave() {
    const data = this.changeset.data as InterTreatmentFilledJournalEvent;
    data.hasAlertingValue = data.sectionsWithColor.some(
      section => section.color == "red" || section.color == "orange"
    );
  }
}
